<template>
    <div v-title data-title="课程学习">
        <Aside></Aside>
        <Header></Header>
        <!-- main -->
        <div  :style="'width:'+ (screenWidth-190) + 'px;'" style="height: calc(100vh - 100px);position: absolute;left: 200px;top: 80px;background-color: #F5F5FA;overflow: auto;">
            <div style="height: 40px;line-height: 40px;padding-top: 20px;padding-left: 20px;">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/Course' }">课程管理</el-breadcrumb-item>
                    <el-breadcrumb-item>课程学习（{{ courseName }}）</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            
            <div class="main_div" :style="'width:'+ (screenWidth-250) + 'px;'" style="margin-top: 20px;">
                <div class="tree_div">
                    <el-tree
                        :data="tree.treeData"
                        node-key="id"
                        default-expand-all
                        :props="tree.defaultProps" @node-click="handleTreeNodeClick">
                        <span slot-scope="{ _, data }" class="tree_span" :style="data.type == 'resource' ? 'color: #67C23A;' : data.type == 'exam' ? 'color: #409EFF;' : ''">
                            {{ data.title }}
                        </span>
                    </el-tree>
                </div>
                <div style="height: 20px;"></div>
            </div>
            <el-drawer
                size="60%"
                :visible.sync="drawer"
                :direction="direction"
                :before-close="handleClose">
                
                <div style="height: 30px;text-align: left;padding-left: 10px;font-size: 20px;font-weight: 700;">{{tree.clickRecourseName}}</div>
                <div :style="'height:'+ (screenHeight - 140) + 'px'" class="tree" style="width: 93%;margin-left: 5%;margin-top: 20px;">
                    <el-scrollbar style="height:100%;width:100%;" v-if="nodeType == 'resource'">
                        <el-backtop></el-backtop>
                        <img v-if="courseData.ext == 'png'" :src="courseDataInfo.url" style="width: 100%;height: auto;" alt="">
                        <video v-else-if="courseData.ext == 'mp4'" oncontextmenu="return false;" controlslist="nodownload" :src="courseDataInfo.url" style="width: 100%;height: auto;" autoplay ref="vueRef"></video>
                        <el-button v-else-if="courseData.ext == 'html'" @click="webGl(courseDataInfo.url)" type="primary">点击进行WebGl资源学习</el-button>
                        <iframe v-else-if="courseData.ext == 'pdf'" :src="courseDataInfo.url" style='width: 95%;margin: 0px;border: none;' :style="'height:'+ (screenHeight - 250) + 'px'" />
                    </el-scrollbar>
                    <el-scrollbar style="height:100%;width:100%;" v-if="nodeType == 'exam' && courseDataInfo != '' && courseDataInfo != undefined">
                        
                        <div style="width: 90%;" v-cloak v-for="(item, index) in courseDataInfo" :key="index">
                            <el-backtop></el-backtop>
                            <el-form>
                                <el-form-item style="border: solid 1px #eee">
                                    <div style="text-align: left;padding-left:10px;background-color: #eee">{{item.description | description}}（分值: {{item.score}}）</div>
                                    <el-checkbox-group v-if="item.type == 2"
                                    v-model="courseDataInfo[index].elsearray"
                                    size="medium" 
                                    style="text-align: left;padding-left: 10px">
                                        <el-checkbox v-for="answer in item.answerlist" :label="answer.id" :key="answer.id">{{answer.answerdescription}}</el-checkbox>
                                    </el-checkbox-group>

                                    <el-radio-group v-if="item.type in ['1', '5']"
                                    v-model="courseDataInfo[index].elseindex"
                                    size="medium" style="text-align: left;padding-left: 10px;width: 100%;">
                                        <el-radio v-for="(answer, ind) in item.answerlist" :label="answer.id" :key="ind">{{answer.answerdescription}}</el-radio>
                                    </el-radio-group>

                                </el-form-item>
                            </el-form>
                        </div>
                        <el-button @click="examSubmit" type="primary">提交</el-button>
                        <div style="height:200px;"></div>
                    </el-scrollbar>

                </div>

            </el-drawer>

            <div style="height: 50px;"></div>
        </div>
    </div>
</template>

<script>
    import Aside from './components/Aside.vue'
    import Header from './components/Header.vue'
    export default {
        components: {
            Aside,
            Header
        },
        filters: {
            description(value) {
                if(value) {
                    if(value.indexOf('&nbsp') != -1) {
                        return value.split('&nbsp;').join(' ');
                    } else {
                        return value;
                    }
                }
                
            }
        },
        mounted() {
            this.getTreeData()
        },
        beforeDestroy() {
            clearInterval(this.timer);
        }, 
        data() {
            return {
                activeIndex: '/Course',
                iframeUrl: 'http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf',
                courseName: sessionStorage.getItem('courseName'),
                tree: {
                    treeData: [],
                    defaultProps: {
                        children: 'children',
                        label: 'title'
                    },
                    clickRecourseName: '',
                },
                submitList: {}, //提交考试时所需数据的对象
                nodeType: '', //当前点击节点属于资源还是考试
                courseDataInfo: [], //点击资源节点后请求回的资源节点数据
                courseData: [],
                drawer: false,
                direction: 'rtl',
                learnTime: 0,
                timer: null, //记录学习使用的定时器
                recordPreResourceNode: {}, //用于记录学习时间是给后端发送的之前学习的资源节点信息
            }
        },
        methods: {
            getTreeData() {
                this.$axios.post(this.$global.basUrl+'api/demo/course/course_detail', { id: sessionStorage.getItem('course_id') }).then(res => {
                    var data = res.data
                    if(data.code == 1) {
                        this.tree.treeData = data.data.tree
                    } else {
                        this.statusPd(data)
                    }
                })
            },
            handleTreeNodeClick(data, node) {
                if(node.level == 3) {
                    console.log('%', data)
                    // return;
                    this.nodeType = data.type
                    let resourceNode = {
                        cid: sessionStorage.getItem('course_id'),
                        pid: node.parent.parent.data.id,
                        sid: node.parent.data.id,
                        eid: data.id,
                        num: data.num,
                        type: data.type
                    }
                    this.tree.clickRecourseName = node.parent.parent.data.title+'/'+node.parent.data.title+'/'+node.data.title;
                    this.submitList['cid'] = sessionStorage.getItem('course_id');
                    this.submitList['pid'] = node.parent.parent.data.id;
                    this.submitList['sid'] = node.parent.data.id;
                    this.submitList['eid'] = data.id;
                    this.recordPreResourceNode = resourceNode;
                    this.timerStart();
                    this.getCourseData(resourceNode)
                }
            },
            //获取点击节点的资源细节并做记录
            getCourseData(resourceNode) {
                this.$axios.post(this.$global.basUrl+'api/demo/course/courseStudy', resourceNode).then(res => {
                    var data = res.data
                    if(data.code == 1) {
                        console.log('lccc', data.data)
                        this.courseData = data.data;
                        this.courseDataInfo = data.data.info;
                        this.recordPreResourceNode.course_type = data.data.info.type
                        this.drawer = true;
                    } else {
                        this.statusPd(data)
                    }
                })
            },
            handleClose(done) {
                const vm = this
                this.$confirm('确认停止学习？')
                .then(() => {
                    if(this.$refs.vueRef) {
                        this.$refs.vueRef.pause();
                    }
                    done();
                    this.timerClear();
                })
            },
            //开启定时器
            timerStart() {
                this.learnTime = 0;
                this.timer = setInterval(()=>{
                    this.learnTime++
                }, 1000);
            },
            //清除定时器
            timerClear() {
                clearInterval(this.timer);
                if(this.recordPreResourceNode.type && this.recordPreResourceNode.course_type != 'PDF') {
                    this.recordPreResourceNode.study_time = this.learnTime
                    this.$axios.post(this.$global.basUrl+'api/demo/course/courseRecordAdd', this.recordPreResourceNode).then(res => {
                        if(res.data.code != 1) {
                            this.statusPd(res.data)
                        }
                    })
                }
                
            },
            //考试结果提交
            examSubmit() {
                let submit = {};
                let arr = [];
                let courseDataInfo = this.courseDataInfo.filter((item) => {
                    if(item.elsearray.length > 0 || item.elseindex != '') {
                        return item
                    }
                })
                courseDataInfo.forEach((item, index) => {
                    if (item.type == '2') {
                        let key = item.id
                        let value = item.elsearray
                        arr[key] = value
                    } else if (item.type == '1' || item.type == '5') {
                        let key = item.id
                        let value = item.elseindex
                        arr[key] = value
                    }
                })
                Object.assign(this.submitList, arr);
                this.$axios.post(this.$global.basUrl+'api/demo/course/examinationAdd', this.submitList).then(res => {
                    if(res.data.code == 1) {
                        this.$message({
                            message: '考试已通过,请继续进行学习',
                            type: 'success'
                        })
                        this.drawer = false
                    }
                })
                
            },
        }
    }
</script>

<style scoped lang="less">
    .main_div {
        min-height: 60px;
        margin-left: 20px;
        background-color: #fff;
        border-radius: 8px 8px 8px 8px;
        position: relative;
        .tree_div {
            min-height: 100px;
            // border: solid 1px #F00;
            padding: 20px;
            .tree_span {
                font-size:14px;
                font-family: "Hiragino Sans GB";
            }
        }
    }
</style>